'use client';
import SectionWrapper from './SectionWrapper';
import { Tender } from '@/actions/dtos/tender/tender';
import CarouselWrapper from '@/components/common/CarouselWrapper';
import TenderPreviewCard from '@/components/tender/TenderPreviewCard';

interface LatestTendersProps {
  tenders: Tender[];
}

const LatestTendersSection: React.FC<LatestTendersProps> = ({ tenders }) => {
  return (
    <SectionWrapper>
      <div className="mx-auto flex max-w-7xl flex-col items-center text-center">
        <h2 className="text-3xl font-normal">Neueste Ausschreibungen</h2>
        <p className=" mt-5 max-w-3xl text-base font-normal">
          Hier sehen Sie einen Auszug unserer zuletzt entdeckten Ausschreibungen. Nach einer Registrierung haben Sie die
          Möglichkeit ganz gezielt nach passenden Ausschreibungen auf unserer Plattform zu suchen.
        </p>
        <CarouselWrapper
          items={tenders}
          renderCard={(tender: Tender, index: number) => (
            <TenderPreviewCard tender={tender} key={index} showScore={false} />
          )}
        />
      </div>
    </SectionWrapper>
  );
};

export default LatestTendersSection;
